// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1e0c1o8l{display:inline-block}\n._uiztglyw{-webkit-user-select:none;-ms-user-select:none;user-select:none}", ""]);
// Exports
module.exports = exports;
